import React from "react";

function RecentOrders() {
  const orders = [
    {
      id: "#1001",
      customer: "Arun",
      product: "Premium Plan",
      amount: "₹1,499",
      status: "Paid"
    },
    {
      id: "#1002",
      customer: "Vijay",
      product: "Starter Plan",
      amount: "₹799",
      status: "Pending"
    },
    {
      id: "#1003",
      customer: "Karthik",
      product: "Business Plan",
      amount: "₹2,999",
      status: "Paid"
    },
    {
      id: "#1004",
      customer: "Priya",
      product: "Premium Plan",
      amount: "₹1,499",
      status: "Failed"
    },
    {
      id: "#1005",
      customer: "Deepa",
      product: "Starter Plan",
      amount: "₹799",
      status: "Paid"
    }
  ];

  const statusClass = {
    Paid: "bg-green-100 text-green-700",
    Pending: "bg-yellow-100 text-yellow-700",
    Failed: "bg-red-100 text-red-700"
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-slate-900">Recent Orders</h3>
        <button className="text-sm text-blue-600 font-medium">View All</button>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full min-w-[700px] text-sm">
          <thead>
            <tr className="text-left text-slate-500 border-b">
              <th className="py-3">Order ID</th>
              <th className="py-3">Customer</th>
              <th className="py-3">Product</th>
              <th className="py-3">Amount</th>
              <th className="py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.id} className="border-b last:border-0">
                <td className="py-4 font-medium text-slate-900">{order.id}</td>
                <td className="py-4">{order.customer}</td>
                <td className="py-4">{order.product}</td>
                <td className="py-4">{order.amount}</td>
                <td className="py-4">
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-semibold ${statusClass[order.status]}`}
                  >
                    {order.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default RecentOrders;